'use client'

import { useSearchParams } from 'next/navigation'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'

export const SpoofedUIInfoBar = () => {
  const searchParams = useSearchParams()
  const { serverEnv } = useSiteContext()

  const params: { [anyProp: string]: string } = {}

  searchParams.forEach((value, key) => {
    params[key] = value
  })

  if (serverEnv === 'production') return null

  const fakes = Object.keys(params).filter(item => item.startsWith('fake_'))

  const getFakes = () => {
    return (
      <div>
        <span className="u-mr-8 u-fw-bold">Spoofed UI:</span>
        {fakes.map(key => (
          <span key={key} className="u-mr-8">
            {key.replace('fake_', '')}
          </span>
        ))}
      </div>
    )
  }

  if (fakes.length == 0) return null

  return <div className="col-12 t-light-red c-box">{getFakes()}</div>
}
